import { render, staticRenderFns } from "./WContactModal.yaml?vue&type=template&id=1fac4e90&component"
import script from "./WContactModal.yaml?vue&type=script&lang=ts&component"
export * from "./WContactModal.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports